import { Component, ElementRef, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CU_RADIO_CONTROL_VALUE_ACCESSOR: any = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioInputComponent)
};

/**
 * A class representing a Generic Radio Input Component
 */
const noop = () => {};
@Component({
  providers: [CU_RADIO_CONTROL_VALUE_ACCESSOR],
  selector: 'cu-radio-legacy',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  standalone: false
})
export class RadioInputComponent implements ControlValueAccessor {
  @Input() public options = [];
  @Input() public name = 'radioGroup';
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('value') public _value = '';
  // by the Control Value Accessor
  private readonly onTouchedCallback: () => void = noop;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly onChangeCallback: (_: any) => void = noop;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onTouched: any = () => {};

  // public elementBase = new ElementComponentBase();
  private get element(): HTMLElement {
    // eslint-disable-next-line no-underscore-dangle
    return this._element.nativeElement as HTMLElement;
  }
  constructor(private readonly _element: ElementRef) {}
  /**
   * Get the value of the component by calling the function
   */
  get value(): string {
    return this._value;
  }

  /**
   * Set the value of the component by calling the function
   * @param string val - The string containing selected value.
   */
  set value(v: string) {
    if (v !== this._value) {
      this._value = v;
      this.onChangeCallback(v);
    }
  }

  /**
   * Register a function to tell Angular when the value of the input changes
   * @param function fn - Passing function as parameter.
   */
  public registerOnChange(fn): void {
    this.onChange = fn;
  }

  /**
   * Write a value to the input
   */
  public writeValue(value): void {
    this.value = value;
  }

  /**
   * Register a function to call when the input is touched.
   * @param function fn - Passing function as parameter.
   */
  public registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  /**
   * Setting selected selected value from radio list
   * @param string selectedValue - The string containing selected value.
   */
  public setValue(selectedValue: string): void {
    if (selectedValue !== this.value) {
      this.value = selectedValue;
      this.onChange(this.value);
      this.onTouched();
    }
  }
  // TEMP: function to add unique Ids to radio buttons based on names.
  public setId(name: string): string {
    return 'id-' + name;
  }

  public onValueChange(value: string): void {
    // eslint-disable-next-line no-underscore-dangle
    const _value = value ? value : '';
    if (_value !== this.value) {
      this.onChange(this.value);
      this.onTouched();
    }
  }
}
